class FamilyAntecedents {
    public Remarks: string;

    constructor(fields?: Partial<FamilyAntecedents>) {
        Object.assign(this, fields);
    }
}

export { FamilyAntecedents };
